import {BaseEntity} from "../common/base-entity";

export class CirfDocument extends BaseEntity {
    id: number;
    description: string;
    documentName: string;
    cirfId: number;
    virusScanStatus: VirusScanStatus ;
    sourceId: string;
    documentType: string;

    isVirusClean() : boolean {
        return this.virusScanStatus == VirusScanStatusValue.CLEAN;
    }

    isVirusInfected() : boolean {
        return this.virusScanStatus == VirusScanStatusValue.INFECTED;
    }

    isVirusPending() : boolean {
        return this.virusScanStatus == VirusScanStatusValue.PENDING;
    }

    isVirusInProgress() : boolean {
        return this.virusScanStatus == VirusScanStatusValue.IN_PROGRESS;
    }
}

export type VirusScanStatus = 'INFECTED' | 'PENDING' | 'IN_PROGRESS' | 'CLEAN';

export const VirusScanStatusValue = {
    INFECTED : 'INFECTED',
    PENDING: 'PENDING',
    IN_PROGRESS: 'IN_PROGRESS',
    CLEAN: 'CLEAN'
};